import React from 'react';
import cx from 'classnames';

function percentage(votes, choices) {
  const total = choices.reduce((prev, curr) => prev + curr.votes, 0);
  return votes > 0 ? Math.round(votes / total * 100) : 0;
}

const PollResult = ({ choices }) => {
  const sortedChoices = choices.sort((a, b) => b.votes - a.votes);
  const topVote = sortedChoices[0].votes;

  return (
    <dl className="poll-result">
      {sortedChoices.map(({ votes, label, id }) => {
        const choicePercentage = percentage(votes, choices);
        return (
          <dd className={cx('percentage', { highscore: votes === topVote })} key={id}>
            <span className="text">
              {`${choicePercentage} % `}
              {label}
            </span>
            <div style={{width: choicePercentage + '%'}} className="line" />
          </dd>
        );
      })}
    </dl>
  );
};

PollResult.propTypes = {
  choices: React.PropTypes.array.isRequired,
};

export default PollResult;



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/PollResult.jsx